import React, { useState } from "react";
import { Box, IconButton, Tooltip, Typography, styled, useMediaQuery, useTheme } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QRCode from "./QRCode";
interface IQRCodeCardProps {
  value: string;
  children?: React.ReactNode;
}


const StyledBorderedBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  border: `2px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '10px',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-3px',
    left: '10%',
    height: '4px',
    width: '40%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  position: 'absolute',
  top: '-1rem',
  left: 'calc(10% + 20%)',
  transform: 'translateX(-50%)',
  zIndex: 10,
  textTransform: "uppercase",
}));

const QRCodeCard: React.FC<IQRCodeCardProps> = ({ value, children }) => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const theme = useTheme()

  const qrBoxStyle = {
    height: '30rem',
    width: '80vw',
    maxWidth: '20rem',
    maxHeight: '30vh',
  };

  const onCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setIsSnackbarOpen(true);
    } catch (err) {
    }
  };
  const handleSnackbarClose = () => {
    setIsSnackbarOpen(false);
  };
  const snackContent = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleSnackbarClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  )
  return (
    <Box className="no-select" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px', }}>
      <StyledBorderedBox p={{md: 4, xs: 2}}>
       <Box sx={qrBoxStyle} display={"flex"} justifyContent="center">  
          <QRCode value={value} />
        </Box>

        <StyledTitle variant="h6">
          Scan Mich
        </StyledTitle>
        {
          children ? children
            :
            <Box height="2rem"></Box>
        }
        <Box sx={{ position: "absolute", bottom: 0, right: 0, }}>
          <Tooltip title="Kopiere Link in Zwischenablage">
            <IconButton onClick={onCopyLink} size="large">
              <ContentCopyIcon style={{ fontSize: "35px", color: theme.palette.text.primary }} />
            </IconButton>
          </Tooltip>
        </Box>
      </StyledBorderedBox>
      <Snackbar
        open={isSnackbarOpen}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Link in die Zwischenablage kopiert"
        action={snackContent}
      />
    </Box>
  );
};

export default QRCodeCard;
